module.exports = "<app-player></app-player>\r\n"